







































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("gaps", ["priority"]),
})
export default class PriorityFilter extends Vue {
  id = "priority-filter-popover";
  target = "priority-filter-target";
  priority!: Array<any>;
  list = Array<any>();
  async checkPriority() {
    this.list.forEach((p) => {
      p.checked = true;
    });
  }
  async uncheckPriority() {
    this.list.forEach((p) => {
      p.checked = false;
    });
  }
  get checkedPriority(): Array<any> {
    return this.list
      .filter((p) => {
        return p.checked;
      })
      .map((p) => p.id);
  }
  search() {
    const filter = JSON.parse(JSON.stringify(this.checkedPriority));
    this.$store.commit("gaps/SET_PRIORITY_FILTER", filter);
    this.close();
  }
  clear() {
    this.uncheckPriority();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { priorityList } = this.$store.state.gaps.filter;
    this.list = JSON.parse(JSON.stringify(this.priority)).map((p) => {
      p.checked = priorityList.includes(p.id);
      return p;
    });
  }
}
